import { Cart } from "@lazarentertainment/web-design-system/components/iconOutline"
import { useLayoutContext } from "client/components/layout"
import { Button } from "client/designSystem/Button"
import { useProductsByIdsQuery } from "client/graphql/storefront-api"
import ResponsiveLoader from "shared/components/ResponsiveLoader"
import { RozyLayout } from "shared/constants/views"

import { isProduct } from "../../utils/isProduct"
import { useCartContext } from "../cart/CartContext"
import { DiscountCodeNotice } from "../DiscountCodeNotice"
import { CommerceView, useShopContext } from "../ShopContext"

import { ShopifyProductTile } from "./ShopifyProductTile"

import styles from "./MultiProductSelection.module.css"

const MultiProductSelection = () => {
  const {
    shop: { activeSale },
    setCurrentlySelectedProductId,
    setView: setCommerceView,
    setAddedProduct,
  } = useShopContext()
  const { visibleProductIds, featuredProductId } = activeSale
  const { cart } = useCartContext()
  const { layout } = useLayoutContext()

  const {
    data: { products } = {},
    previousData: { products: previousProductsData } = {},
    loading: productsLoading,
  } = useProductsByIdsQuery({
    variables: { ids: visibleProductIds },
    context: { useStorefrontAPI: true },
  })

  if (productsLoading || (!products && !previousProductsData)) {
    return <ResponsiveLoader />
  }

  // Display previous data while query is refetching to avoid flicker
  const productsToRender = products ?? previousProductsData ?? []

  const featuredProduct = productsToRender.find((product) => {
    return isProduct(product) && product.id === featuredProductId
  })

  const onCartClick = () => {
    setCommerceView(CommerceView.CART)
    setAddedProduct(null)
  }

  return (
    <div className={styles.multiProductSelectionOuterContainer}>
      <div className={styles.multiProductSelection}>
        <div className={styles.productListingsWrapper}>
          {activeSale.discountCode && (
            <DiscountCodeNotice code={activeSale.discountCode} />
          )}
          {isProduct(featuredProduct) && (
            <ShopifyProductTile
              product={featuredProduct}
              setCurrentProductId={setCurrentlySelectedProductId}
              isFeatured
            />
          )}
          {productsToRender.map(
            (product) =>
              isProduct(product) &&
              (!isProduct(featuredProduct) ||
                product.id !== featuredProduct?.id) && (
                <ShopifyProductTile
                  key={product.id}
                  product={product}
                  setCurrentProductId={setCurrentlySelectedProductId}
                />
              ),
          )}
        </div>
        {layout === RozyLayout.MOBILE &&
          cart &&
          cart.totalQuantity > 0 && (
            <div className={styles.cartButtonContainer}>
              <Button
                variant="primary"
                icon={Cart}
                onClick={onCartClick}
                data-full-width
                data-robot="product-list-view-cart"
              >
                {`Cart (${cart.totalQuantity} ${
                  cart.totalQuantity === 1 ? "item" : "items"
                })`}
              </Button>
            </div>
          )}
      </div>
    </div>
  )
}

export default MultiProductSelection
